/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import * as Platform from '../Platform';
import { PlayerAbstract } from '../PlayerAbstract';
import { BrowserReloadable } from '../mixins/BrowserReloadable';
import { NamedValueCacheLocalStorageMixin } from '../mixins/NamedValueCacheLocalStorageMixin';
import { RandomUuidHardwareIdGeneratorMixin } from '../mixins/RandomUuidHardwareIdGeneratorMixin';
import { isUrlQueryPlatform } from '../PlatformCheck';
import { Permission } from '../Permissions';

/**
 * @constructor
 * @augments PlayerAbstract
 * @implements NamedValueCacheInterface
 * @implements ReloadInterface
 * @mixes BrowserReloadable
 * @mixes NamedValueCacheLocalStorageMixin
 * @mixes RandomUuidHardwareIdGeneratorMixin
 */
function BrowserPlayer() {
    PlayerAbstract.call(this);

    this.addPermission(Permission.MUTE_BEFORE_USER_INTERACTION);
}

BrowserPlayer.prototype = Object.create(BrowserReloadable(PlayerAbstract).prototype);
NamedValueCacheLocalStorageMixin.call(BrowserPlayer.prototype);
RandomUuidHardwareIdGeneratorMixin.call(BrowserPlayer.prototype);
BrowserPlayer.prototype.constructor = BrowserPlayer;

/**
 * @inheritDoc
 */
BrowserPlayer.prototype.type = Platform.UNKNOWN;

/**
 * @inheritDoc
 */
BrowserPlayer.prototype.name = 'Browser Player';

/**
 * @returns {boolean}
 */
BrowserPlayer.isTheRunningPlatform = function () {
    const thisPlatformIsRunning = isUrlQueryPlatform('Browser');
    if (typeof thisPlatformIsRunning === 'boolean') {
        return thisPlatformIsRunning;
    }

    // use fallback check
    return false;
};

export { BrowserPlayer };
